const crmRoutes = [
  {
    path: '/crm/tipofollowup',
    name: 'crm.tipofollowup',
    component: () => import('../views/crm/TipoFollowUp.vue'),
  },
  {
    path: '/crm/cadastro-tarefas',
    name: 'crm.cadastro-tarefas',
    component: () => import('../views/crm/CadastroTarefas.vue'),
  },
  {
    path: '/crm/PaineisContatos',
    name: 'crm.PaineisContatos',
    component: () => import('../views/crm/PaineisContatos.vue'),
  },
  {
    path: '/crm/origemcontato',
    name: 'crm.cadastroorigemcontato',
    component: () => import('../views/crm/OrigemContato.vue'),
  },
  {
    path: '/crm/fasesnegociacoes',
    name: 'crm.fasesnegociacoes',
    component: () => import('../views/crm/FasesNegociacoes.vue'),
  },
  {
    path: '/crm/configuracao/camposextras',
    name: 'crm.camposextras',
    component: () => import('../views/crm/CamposExtras.vue'),
  },
  {
    path: '/crm/cadastrodesmtp',
    name: 'crm.cadastrodesmtp',
    component: () => import('../views/crm/CadastroDeSMTP.vue'),
  },
];

export default crmRoutes;
